import React from 'react';
import './ButtonDelete.css';

const ButtonDelete = ({ children, className = '', type = 'button', onClick, disabled = false, ariaLabel }) => {
	return (
		<button
			type={type}
			className={`btn-delete ${className}`}
			onClick={onClick}
			disabled={disabled}
			aria-label={ariaLabel}
		>
			{children}
		</button>
	);
};

export default ButtonDelete;
